module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\n<fieldset class="shape-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".shape-properties-container">Box</legend>\n    <div class="shape-properties-container collapse collapse-target">\n        <div class="zmags-input-control">\n            <div class="shape-background-color-library color-library"></div>\n            <label class="color-library-custom">\n                Custom Color:\n                <div class="shape-background-color-box color-box"></div>\n                <input type="text" class="shape-background-color-input color-input">\n            </label>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="style-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/shapeWidget/ShapeWidgetPropertiesView.tpl
// module id = 2066
// module chunks = 0